// Pure types + sort for the "Incidents this week" section of the Weekly
// Digest page. Split out of weekly-digest.tsx so the sort can be unit-tested
// without importing the whole TSX module (which transitively touches
// `document` at import time via portal-config).

// Mirrors the IncidentThisWeek shape from
// packages/api/src/handlers/aggregate-weekly-digest.ts.
export interface IncidentThisWeekLinkedPr {
  org: string;
  repo: string;
  pr_number: number;
  confidence: number;
  reason: string;
  has_bot_approved_artifact: boolean;
}

export interface IncidentThisWeek {
  incident_id: string;
  source: 'confluence-postmortem' | 'pagerduty-statuspage';
  source_url: string;
  title: string;
  arch_group: 'edge' | 'engine' | 'hero' | null;
  severity: string | null;
  occurred_at: string;
  linked_prs: IncidentThisWeekLinkedPr[];
  any_bot_approved_linked_pr: boolean;
}

/** Bot-approved-linked incidents first (explicit EM/TL review queue),
 *  then occurred_at desc within each group. Stable on ties via Array.sort. */
export function sortIncidentsThisWeek(incidents: IncidentThisWeek[]): IncidentThisWeek[] {
  return [...incidents].sort((a, b) => {
    if (a.any_bot_approved_linked_pr !== b.any_bot_approved_linked_pr) {
      return a.any_bot_approved_linked_pr ? -1 : 1;
    }
    return a.occurred_at < b.occurred_at ? 1 : a.occurred_at > b.occurred_at ? -1 : 0;
  });
}
